import { formatCurrency } from "../../../../services/format";
import { RetryTransactions } from "../../../../services/requests/billing/dewar-billing-requests";
import { FormItemType } from "../../../UI/view/component-map";
import { connectListView, ListView, ListViewColumnType } from "../../../UI/view/list-view";
import { failedTransactionsDS } from "./data-source";

export const columns = [
  {
    Header: '',
    accessor: 'checked',
    type: ListViewColumnType.checkbox,
    excludeGlobalFilter: true,
  },
  {
    Header: 'Order Number',
    accessor: 'paymentSourceBatchNumber',
    type: ListViewColumnType.link,
    linkPath: ({ val, row }) => row.original.url,
    newLink: true
  },
  {
    Header: 'Customer #',
    accessor: 'customerId',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ row: { original: { amount } } }) => formatCurrency(amount),
  },
  {
    Header: 'Authorization #',
    id: 'authorizationNumber',
    accessor: ({ authorizationNumber }) => authorizationNumber,
  },
  {
    Header: 'Transaction Date',
    accessor: 'transactionDate',
    defaultSort: true,
    defaultSortDirection: 'desc',
    type: ListViewColumnType.date
  },
  {
    Header: 'Failure Source',
    id: 'failureSource',
    accessor: ({ failureSource }) => failureSource,
  },
  {
    Header: 'Failure Code',
    id: 'failureCode',
    accessor: ({ failureCode }) => failureCode,
  },
  {
    Header: 'Failure Reason',
    id: 'failureReason',
    accessor: ({ failureReason }) => failureReason,
  },
];
export const failed = {
  toolbar: [
    {
      type: FormItemType.button,
      label: 'Retry Selected',
      permissions: {
        read: [1, 14, 15, 18],
        write: [1, 15],
        admin: [1, 15],
      },
      handler: async ({ getValues, confirm, loadData }) => {
        const vals = getValues();
        const transactions = vals.failedTransactionsSelection;
        if (!transactions?.length) {
          await confirm('No transactions are selected. Please select transactions from the list below then press retry.', true)
        } else {
          if (await confirm("Are you sure you want to retry the selected transactions?") == true) {
            let isError = false;
            try {
              await RetryTransactions({ transactions: transactions.map(b => ({ transactionId: b.transactionId })) });
            } catch (e) {
              isError = true;
              await confirm('There was an error retrying transactions:' + e, true)
            }
            if (!isError) {
              await confirm('Transactions have been retried successfully.', true);
              loadData();
            }
          }
        }
      }
    }
  ],
  columns: columns
} as ListView;

export const [Failed, _] = connectListView(failed, failedTransactionsDS);